import { seo } from '../seo';
export { WhoisPage as default } from '../../src/pages/WhoisPage';
export const meta = () => seo('whois');
